import React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { CircleX } from "lucide-react";

const CanceledCard = () => {
  return (
    <div className="border-0.5 border-border flex flex-col gap-6 rounded-xl p-0 shadow-sm w-full">
      <div className="flex flex-col items-start gap-2 p-4">
        <div className="flex flex-row gap-3 items-start w-full">
          <Button
            icon
            variant="secondary"
            UNSAFE_className="bg-neutral-soft border-border"
          >
            <CircleX size={16} className="text-muted" />
          </Button>
          <div className="flex-1 flex flex-col gap-1">
            <div className="text-sm font-semibold">Request canceled</div>
            <p className="text-xs text-muted relative">
              You canceled this request. No further changes will be made.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CanceledCard;
